module.exports = __webpack_public_path__ + "img/onboarding_delivery_key_pl.f7a2ae92.png";